import { Fragment } from "react";

const TOKEN_RE =
  /(\*\*[^*]+\*\*|__[^_]+__|`[^`]+`|\*[^*]+\*|_[^_\s][^_]*_)/g;

const inlineNodes = (text, keyPrefix) => {
  const s = String(text ?? "");
  if (!s) return null;
  const nodes = [];
  let last = 0;
  let i = 0;
  TOKEN_RE.lastIndex = 0;
  let match = TOKEN_RE.exec(s);
  while (match) {
    if (match.index > last) {
      nodes.push(s.slice(last, match.index));
    }
    const token = match[0];
    const key = `${keyPrefix}-${i}`;
    i += 1;
    if (token.startsWith("**") || token.startsWith("__")) {
      nodes.push(<strong key={key}>{token.slice(2, -2)}</strong>);
    } else if (token.startsWith("`")) {
      nodes.push(<code key={key}>{token.slice(1, -1)}</code>);
    } else {
      nodes.push(<em key={key}>{token.slice(1, -1)}</em>);
    }
    last = match.index + token.length;
    match = TOKEN_RE.exec(s);
  }
  if (last < s.length) nodes.push(s.slice(last));
  return nodes;
};

export const AskRichText = ({ children }) => {
  const text = String(children ?? "");
  if (!text) return null;
  const lines = text.split("\n");
  return lines.map((line, i) => (
    <Fragment key={`ln-${i}`}>
      {i > 0 ? <br /> : null}
      {inlineNodes(line, `ln-${i}`)}
    </Fragment>
  ));
};
